<template>
  <el-dialog
    class="common-popup"
    :class="device.isMobile ? 'common-popup-mobile' : ''"
    :title="dialogTitle"
    :visible.sync="visible"
    :destroy-on-close="true"
    :append-to-body="true"
    @close="closeHandle"
    style="z-index: 10000"
    v-if="visible"
  >
    <interactionQuestion :content="content"></interactionQuestion>
  </el-dialog>
</template>

<script>
/*
通用弹窗
*/
export default {
  name: "interactionQuestionPopup",
  components: {
    interactionQuestion: () => import("../question/interaction.vue"), //解决递归加载组件报错
  },
  props: {
    dialogTitle: {
      type: String,
      default: ""
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: ""
    },
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  watch: {
    dialogVisible(newVal) {
      this.visible = newVal
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    closeHandle() {
      this.$emit('dialogClose')
    },
  }
}
</script>

<style lang="scss" scoped>
.common-popup{
  text-indent: 0;
}
/deep/.el-dialog {
  width: 750rem;
  margin: 0;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 10rem 10rem 0rem 0rem;
  min-height: 60%;
  max-height: 90%;
  display: flex;
  flex-direction: column;

  .el-dialog__header{
    flex: 0 0 71rem;
    border-bottom: 1rem solid #E3E3E3;
    padding: 20rem 30rem 10rem;
    .el-dialog__title{
      font-size: 20rem;
      line-height: 40rem;
      color: #333;
    }
    .el-dialog__headerbtn{
      top: 30rem;
      right: 30rem;
    }
  }
  .el-dialog__body{
    flex: 1;
    padding: 20rem 0 10rem;
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
  }
}

.common-popup-mobile{
  /deep/.el-dialog{
    .el-dialog__header{
      border-bottom: 2rem solid #E3E3E3;
      padding: 30rem 26rem;
      .el-dialog__title{
        font-size: 36rem;
        line-height: 48rem;
      }
      .el-dialog__headerbtn{
        font-size: 40rem;
        top: 30rem;
        right: 30rem;
      }
    }
    .el-dialog__body{
      padding: 0;
    }
  }
}
</style>